import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";
import { applyTile } from "../engine/effects.js";

/**
 * TileNode
 * --------
 * Tiles the input canvas into a grid of repeated, scaled-down copies.
 */
export class TileNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Tile";

    this.properties = {
      columns: 2,
      rows: 2,
    };

    this.addInput("Canvas", "canvas");
    this.addOutput("Canvas", "canvas");

    addDrivableSlider(this, "Columns", "columns", 2, 1, 8, 1);
    addDrivableSlider(this, "Rows", "rows", 2, 1, 8, 1);

    finalizeDrivableSliders(this, 1);

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");

    this.size = [200, 80];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    if (!input) { this.setOutputData(0, null); return; }

    const w = input.width;
    const h = input.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(input, 0, 0);

    applyTile(ctx, w, h, { columns: this.properties.columns, rows: this.properties.rows });

    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("effects/Tile", TileNode);
